import { render, staticRenderFns } from "./ListaCargas.vue?vue&type=template&id=06cdc464&"
import script from "./ListaCargas.vue?vue&type=script&lang=js&"
export * from "./ListaCargas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports